/**
 * @generated SignedSource<<8f5f20226b6ccf110e82efcbbc76f452>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schedulable",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AssetAttributesUpdateModal_updateSchedulableEntityMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateSchedulableEntityPayload",
                    "kind": "LinkedField",
                    "name": "updateSchedulableEntity",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfISchedulableEntity",
                            "kind": "LinkedField",
                            "name": "entityEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AssetAttributesUpdateModal_updateSchedulableEntityMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateSchedulableEntityPayload",
                    "kind": "LinkedField",
                    "name": "updateSchedulableEntity",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfISchedulableEntity",
                            "kind": "LinkedField",
                            "name": "entityEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c1bc294f70a8c66f0f31b67e087d14f4",
            "id": null,
            "metadata": {},
            "name": "AssetAttributesUpdateModal_updateSchedulableEntityMutation",
            "operationKind": "mutation",
            "text": "mutation AssetAttributesUpdateModal_updateSchedulableEntityMutation(\n  $model: UpdateSchedulableEntityRequestInput!\n) {\n  updateSchedulableEntity(model: $model) {\n    entityEdge {\n      node {\n        __typename\n        schedulable\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "7e074e4d385a276165a314661491058c";
export default node;
